<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
  value: { type: Object, required: true },
});

const emit = defineEmits(['update:value']);
const { t } = useI18n();
const update = (field, fieldValue) =>
  emit('update:value', { ...props.value, [field]: fieldValue });
</script>

<template>
  <div class="grid gap-4">
    <h2 class="text-lg font-semibold text-lais-text">
      {{ t('POST_SALE.TOPICS.REINFORCEMENT.TITLE') }}
    </h2>
    <fieldset class="grid gap-2">
      <legend class="text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.TOPICS.REINFORCEMENT.MOMENT') }}
      </legend>
      <label
        v-for="option in catalog.reinforcement_moments || []"
        :key="option.id"
        class="flex items-center gap-2 text-sm text-lais-text-body"
      >
        <input
          type="radio"
          name="reinforcement-moment"
          :checked="value.moment === option.id"
          :value="option.id"
          @change="update('moment', $event.target.value)"
        />
        {{ option.label }}
      </label>
    </fieldset>
    <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
      {{ t('POST_SALE.TOPICS.REINFORCEMENT.OBSERVATION') }}
      <textarea
        :value="value.observation"
        rows="3"
        class="rounded-lais border border-lais-border bg-white p-2 font-normal"
        :placeholder="t('POST_SALE.TOPICS.REINFORCEMENT.PLACEHOLDER')"
        @input="update('observation', $event.target.value)"
      />
    </label>
  </div>
</template>
